<div class="main-layout">
  <app-header></app-header>
  <div class="main-content">

    <router-outlet></router-outlet>
    <app-loading-overlay></app-loading-overlay>
  </div>
  <app-footer></app-footer>
</div>

@if (isSpinnerVisible) {
  <mat-progress-bar class="loader" mode="indeterminate" value="40"></mat-progress-bar>
}
